import { lazy, Suspense } from 'react';
import './charts.css';
import { ChartPlaceholder } from './ChartPlaceholder';
import type { CombinedChartProps } from './CombinedChartImpl';

// Lazy-grens — zie PriceChart.tsx voor de toelichting.
const CombinedChartImpl = lazy(() =>
  import('./CombinedChartImpl').then(m => ({ default: m.CombinedChart })),
);

export type { CombinedChartProps } from './CombinedChartImpl';

export function CombinedChart(props: CombinedChartProps) {
  return (
    <Suspense fallback={<ChartPlaceholder />}>
      <CombinedChartImpl {...props} />
    </Suspense>
  );
}
